module.exports = __webpack_public_path__ + "img/compute.34949b1a.png";